import type { FaireProductEntity } from "../../entity_types/product";

export const p_f5cq5h5edc: FaireProductEntity = {
  token: "p_f5cq5h5edc",
  type: "product",
  name: "Exhausted American Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0acfe47468ced7d6dd293542e6307f2af046f13a5acb9f533f111c45be4af134.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/54476b456f011901ffc5b7f965434513680b4c8fccfeb6bfe9583f12a5af808e.jpeg",
    "https://cdn.faire.com/fastly/63b2499bf6674dbc6b16fdb54e7d18b349bb48cf4ddc384a80f322de08367bb1.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/a541bc39bc9fe1ab75f4e9e276fcdb9e963d8367351f2aa2ca92a4758e56b9ae.jpeg",
    "https://cdn.faire.com/fastly/2aaa8f2b8eb33c24551d5c7108d797951de7febab577852ff2ed94b4a1eae302.jpeg",
    "https://cdn.faire.com/fastly/a9c34148a68065766189c6d52166020e37316313623b51155ec8ad2957c84c3e.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you're an American and you've been paying any attention to wtf is happening out here, then you deserve a massage 💆 . If your regular socks aren't providing the comfort and honesty you need, well, these are the socks you've been looking for!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:55.770Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
